import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

@Component({
    selector: 'atx-select',
    template: `<ngx-select class="w-100"
            [items]="model"
            [allowClear]="false"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [noAutoComplete]="!autoComplete"
            [optionTextField]="optionTextField"
            [optionValueField]="optionValueField"
            [optGroupLabelField]="optGroupLabelField"
            [optGroupOptionsField]="optGroupOptionsField"

            (typed)="inputTyped($event)"
            (selectionChanges)="onSelectionChanges($event)">
</ngx-select>
`,
    styles: [``],
})

export class AtxSelectComponent implements OnChanges {
    @Input() public model: object[];
    @Input() public readonly disabled: boolean;
    @Input() public readonly placeholder: string = '';
    @Input() public readonly maxOptions: number = 100;
    @Input() public readonly autoComplete: boolean = true;
    @Input() public readonly optionValueField: string = 'id';
    @Input() public readonly optionTextField: string = 'text';
    @Input() public readonly optGroupLabelField: string = 'text';
    @Input() public readonly optGroupOptionsField: string = 'children';

    @Output('onTyped') public readonly fireTyped: EventEmitter<string> = new EventEmitter();
    @Output('onChange') public readonly fireChange: EventEmitter<object> = new EventEmitter();

    public inputTyped = (text: string) => this.fireTyped.emit(text);

    public onSelectionChanges([{ data, _parent }]) {
        if (_parent) {
            this.model.map((element: any) => {
                if (element[this.optionTextField] === _parent.label) {
                    const children = element.children.find((child) => child.id === data.id);

                    this.fireChange.emit({
                        [this.optionValueField]: element[this.optionValueField],
                        ...children,
                    });
                }
            });
        } else {
            this.fireChange.emit(data);
        }
    }

    public ngOnChanges() {
        if (this.model && this.model[0]) {
            this.onFilter();
        }
    }

    private onFilter() {
        if ((this.model[0] as any).children) {
            this.filterChildren();
        } else {
            this.filter();
        }
    }

    private filter() {
        this.model = this.model.slice(0, this.maxOptions);
    }

    private filterChildren() {
        const temporal = [];

        temporal.push(...this.model.map((element: any) => {
            element.children = element.children.slice(0, this.maxOptions);

            return element;
        }));

        this.model = temporal;
    }
}
